/** @jsxImportSource @emotion/react */

import useStyles from './styles';

const HiddenContent = ({ children, ...rest }) => {
  const styles = useStyles();

  return (
    <span css={styles.hidden} {...rest}>
      {children}
    </span>
  );
};

export default HiddenContent;
